(function ($) {
  Drupal.behaviors.offersDetailItem = {
    attach: function (context) {
      var $items = $('.offers-details-item', context);

      $items.each(function (index, val) {
        var $item = $(this);
        var $detailsLink = $('.offers-details-item__link', this);

        $detailsLink.click(function (event) {
          event.preventDefault();
          $item.toggleClass('offers-details-item--dropdown');
          $items.not($item).removeClass('offers-details-item--dropdown');
          if ($items.hasClass('offers-details-item--dropdown')) {
            $(this).attr('aria-expanded', 'true');
          } else {
            $(this).attr('aria-expanded', 'false');
          }
        });
      });
    }
  };

  Drupal.behaviors.showWelcome15 = {
    attach: function (context) {
      var $items = $('#welcome15-offer.offers-details-item', context);

      $items.each(function (index, val) {
        var $item = $(this);
        var $detailsLink = $('.offers-details-item__link', this);

        $detailsLink.unbind().click(function (event) {
          event.preventDefault();
          $(document).trigger('email_signup:launch');
        });
      });
    }
  };
})(jQuery);
